import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import styles from "./HowItWorks.module.css"

const HowItWorks = () => {
  const data = useStaticQuery(graphql`
    query howItWorksQuery {
      exampleImg: file(relativePath: { eq: "donate/example.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 314, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <div className={styles.howItWorks}>
      <figure>
        <Img fluid={data.exampleImg.childImageSharp.fluid} alt={"How it works"}/>
      </figure>
      <div className={styles.content}>
        <h3>Donations made easy</h3>
        <p>
          Individuals can donate seamlessly to their charities of choice using simple commands. Or they can set up
          weekly donations each week when everyone can celebrate their impact together.
        </p>
        <h3>Impact Dashboard</h3>
        <p>
          Every Cultural Currency donation drives real impact which can be viewed by your team on their personal
          dashboard alongside the UN Sustainable Development Goals impacted. An example can be seen here.
        </p>
      </div>
    </div>
  )
}


export default HowItWorks